import { render, staticRenderFns } from "./ProposalStat.vue?vue&type=template&id=c631a388&scoped=true&"
import script from "./ProposalStat.vue?vue&type=script&lang=js&"
export * from "./ProposalStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c631a388",
  null
  
)

export default component.exports